"use strict";
export const debugMode = (() => {
  var _a;
  const debugValue = (_a = document.querySelector('meta[name="debug-info"]')) == null ? void 0 : _a.getAttribute("value");
  return (debugValue == null ? void 0 : debugValue.toLowerCase()) === "true";
})();
export const railsVersion = (() => {
  var _a;
  return (_a = document.querySelector('meta[name="rails-version"]')) == null ? void 0 : _a.getAttribute("value");
})();
